import api from "@/plugins/api";
import { logger } from "@/infrastructure/services/LoggerService";
export class NotificationPreferencesService {
    async getNotificationPreferences() {
        try {
            const response = await api.get("/account-preference/notifications", {
                unwrapEnvelope: true,
            });
            return response.data;
        }
        catch (error) {
            logger.debug("Failed to get notification preferences:", error);
            throw error;
        }
    }
    async updateNotificationPreferences(preferences) {
        try {
            await api.put("/account-preference/notifications", preferences, {
                unwrapEnvelope: true,
            });
        }
        catch (error) {
            logger.debug("Failed to update notification preferences:", error);
            throw error;
        }
    }
}
